import { useSelector } from 'react-redux';
import { catalogBrandNameSelector } from '../selectors/globalsSelectors';

export function useBrandName() {
  return useSelector(catalogBrandNameSelector) ?? 'geberit';
}
